/*eslint-disable*/
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import { countries, language, default_country_code } from "config"; // <- import default

function countryToFlag(isoCode) {
  if (typeof String.fromCodePoint === "undefined") return isoCode;
  return isoCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
}

const useStyles = makeStyles({
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});

export default function IdentityCountrySelect({
  value,
  onChange,
  disabled = false,
  style = {},
  id = "identity-country-select",
}) {
  const classes = useStyles();

  // recalc when countries changes
  const options = useMemo(() => countries || [], [countries]);

  const resolvedValue = useMemo(() => {
    // explicit null => no selection
    if (value === null) return null;

    // undefined => fallback to ZA (prefer to return the actual options item if available)
    if (typeof value === "undefined") {
      return options.find((c) => c.code === "ZA") || default_country_code;
    }

    // string -> treat as ISO code
    if (typeof value === "string") {
      return options.find((c) => c.code === value) || null;
    }

    // object -> try to return the canonical options object so equality works
    if (typeof value === "object" && value !== null) {
      const found = options.find((c) => c.code === value.code);
      return found || value;
    }

    return null;
  }, [value, options]);

  return (
    <Autocomplete
      id={id}
      style={{ width: "100%", ...style }}
      options={options}
      classes={{ option: classes.option }}
      autoHighlight
      getOptionLabel={(option) => option.label || ""}
      getOptionSelected={(option, val) =>
        Boolean(option && val && option.code === val.code)
      }
      renderOption={(option) => (
        <>
          <span>{countryToFlag(option.code)}</span>
          {option.label}
        </>
      )}
      disabled={disabled}
      value={resolvedValue}
      onChange={(_, newValue) => {
        if (typeof onChange === "function") {
          onChange(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={language.identity_country_label || "Select ID Country"}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password",
          }}
        />
      )}
    />
  );
}

IdentityCountrySelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ code: PropTypes.string.isRequired, label: PropTypes.string }),
    PropTypes.instanceOf(Object),
  ]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  id: PropTypes.string,
};
